<template>
  <div class="viewDoc">
    <div v-show="showTitle" class="docDiv">
      <h2 style="text-overflow: ellipsis; overflow: hidden">{{ titulo }}</h2>
    </div>
    <div class="docDiv descrArea">
      <v-toolbar flat>
        <v-label>Descripción</v-label>
      </v-toolbar>
      <v-textarea v-if="loaded" :value="documento.descripcion" readonly solo auto-grow rows="1"></v-textarea>
    </div>
    <div class="docDiv">
      <slotbar fluid :slots='2' :slotWidth='400'>
        <template v-slot:slot1>
          <v-label>Contenido</v-label>
        </template>
        <template v-slot:slot2>
          <v-btn style='margin: 2px;' @click="descargarArchivo()" :disabled="awaitingResponse">Descargar {{documento.type==='PDF'?'PDF':'XML'}}</v-btn>
          <v-btn style='margin: 2px;' v-show="showXml || showHtml" @click="descargarArchivo('PDF_XML_EMBEDDED')" :disabled="awaitingResponse">Descargar PDF</v-btn>
        </template>
      </slotbar>
      <v-textarea v-if="loaded && showXml" :value="textoDecoded" readonly solo auto-grow background-color="#fafafa"></v-textarea>
      <iframe v-if='loaded && showHtml' :src='htmlSrc' type='text/html' width='100%' :height='iframeHeight'></iframe>
      <iframe v-if='loaded && showPdf' :src='pdfSrc' type='application/pdf' width='100%' :height='iframeHeight'></iframe>
    </div>
    <div v-if="false" class="docDiv">
      <v-toolbar flat>
        <v-label>XML</v-label>
      </v-toolbar>
      <v-card>
        <v-card-text>
          {{ contenidoXml }}
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import slotbar from '@/components/custom/slotbar.vue';
import { parseXml, xml2json } from '@/utils/xml2json.js';
import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';

export default {
  name: 'VerContrato',
  components: {
    slotbar,
  },
  props: {
    loaded: Boolean,
    documentoInit: Object,
    showTitleInit: Boolean,
  },
  data () {
    return {
      documento: {},
      showTitle: false,
      awaitingResponse: false,
      pdfSrc: '',
      htmlSrc: '',
      iframeHeight: window.innerHeight,
      showPlainVisor: false,
    }
  },
  computed: {
    titulo() {
      if (this.documento.title !== undefined) return this.documento.title;
      return "";
    },
    contenidoXml() {
      if (this.documento.doc !== undefined) return this.documento.doc;
      return '';
    },
    texto() {
      if (this.documento.doc === undefined) return '""';
      const docJson = xml2json(parseXml(this.documento.doc), "");
      const doc = JSON.parse(docJson);
      if (doc['flmy:Contrato'] !== undefined && doc['flmy:Contrato']['flmy:texto'] !== undefined) {
        const strOrObj = doc['flmy:Contrato']['flmy:texto'];
        if (typeof strOrObj === 'object') return strOrObj['#text'];
        else return strOrObj;
      }
      return '""';
    },
    textoDecoded() {
      try {
        return "\n\n" + JSON.parse(this.texto);
      } catch (e) {
        console.warn('textoDecoded: JSON.parse(this.texto) failed. Using this.texto');
        return "\n\n" + this.texto;
      }
    },
    showXml() {
      if (this.documento.type === 'XMLBasic' && this.showPlainVisor) return true;
      return false;
    },
    showHtml() {
      if (this.documento.type === 'XMLBasic') return true;
      return false;
    },
    showPdf() {
      if (this.documento.type === 'PDF' && this.documento.pdfBlob !== undefined) return true;
      return false;
    },
  },
  created() {
    window.addEventListener('resize', this.resizeIframe);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeIframe);
  },
  mounted() {
    this.documento = JSON.parse(JSON.stringify(this.documentoInit));
    this.showTitle = this.showTitleInit;
  },
  methods: {
    getDownloadType(type) {
      if (type === 'XMLBasic') return 'XML';
      return type;
    },
    async descargarArchivo(dlType = null) {
      const defaultToastMessage = 'Error al solicitar la descarga.';
      const defaultConsoleMessage = 'descargarArchivo error';
      try {
        this.awaitingResponse = true;
        const clienteId = this.documento.cliente.id;
        const docId = this.documento.id;
        const downloadType = (dlType !== null ? dlType : this.getDownloadType(this.documento.type));
        const result = await this.$store.dispatch('downloadDocumento', {clienteId, docId, downloadType});
        if (result === null) {
          console.error(defaultConsoleMessage);
          this.$toast.error(defaultToastMessage);
          this.stopWait();
          return;
        }
        const downloadUrl = URL.createObjectURL(result.data);
        const filename = this.getPropertyFromString(result.headers['content-disposition'], 'filename');
        this.downloadFromTempUrl(downloadUrl, filename);
      } catch (e) {
        consoleErrorMessage(e, defaultConsoleMessage);
        toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
      }
      this.stopWait();
    },
    getPropertyFromString(str, propName) {
      var match = str.match(new RegExp('(^| )' + propName + '=([^;]+)'));
      if (match) return match[2].replace(/['"]/g, '');
      else return '';
    },
    downloadFromTempUrl(url, filename) {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    getFileExtension(docType) {
      if (docType === 'XMLBasic') return 'xml';
      if (docType === 'PDF') return 'pdf';
      return 'xml';
    },
    stopWait() {
      var self = this;
      window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
    },
    resizeIframe() {
      this.iframeHeight = window.innerHeight;
    },
  },
  watch: {
    documentoInit: {
      handler(newValue, oldValue) {
        this.documento = JSON.parse(JSON.stringify(newValue));
        this.documento.doc = newValue.doc;
        this.documento.pdfBlob = newValue.pdfBlob;
        if (this.showHtml && this.documento.doc !== undefined) this.htmlSrc = URL.createObjectURL(this.documento.doc);
        if (this.showPdf && this.documento.pdfBlob !== undefined) this.pdfSrc = URL.createObjectURL(this.documento.pdfBlob);
      }
    },
    showTitleInit: {
      handler(newValue, oldValue) {
        this.showTitle = newValue;
      }
    },
  },
};
</script>
<style scoped>
.viewDoc { border: none; }
.docDiv {
  margin: 5% 10% 5% 10%;
}
.v-textarea >>>textarea {
  font-size: 14pt;
  margin: 10%;
}
.descrArea .v-textarea >>>textarea {
  font-size: 12pt;
  margin: 0% 10% 0% 10%;
}
</style>
